import { InstructorApprovalLetterPanel } from '@features/instructors/components/header/actions-tiles/approval-letter-panel/InstructorApprovalLetterPanel';
import { useInstructorNavigation } from '@features/instructors/hooks/use-instructor-navigation/useInstructorNavigation';
import * as React from 'react';

const InstructorApprovalLetterRoute = React.memo((): React.ReactElement => {
  const { navigateToInstructorsList } = useInstructorNavigation();

  return <InstructorApprovalLetterPanel onClose={navigateToInstructorsList} />;
});

InstructorApprovalLetterRoute.displayName = 'InstructorApprovalLetterRoute';
export { InstructorApprovalLetterRoute };
